// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___r5I8b","root_btn":"style-module__root_btn___yHeZd","root_counter":"style-module__root_counter___iKKcw","root__wrapper":"style-module__root__wrapper___hdHQs","root__wrapper_item":"style-module__root__wrapper_item___s5PTl"};
    if(module.hot) {
      // 1697460471776
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  